import { keyBy } from 'lodash';
import classes from './SettingsSelectSolutionMulti.module.scss';

const normalize = (s = '') =>
  String(s || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[\u2010-\u2015\u2212\u2043\uFE58\uFE63\uFF0D]/g, '-') 
    .replace(/\s+/g, ' ')
    .trim();

const gradeKey = (name = '') => {
  const n = normalize(name);

  const mRange = n.match(/\b(\d+)\s*-\s*(\d+)\b/);
  if (mRange) {
    const a = parseInt(mRange[1], 10);
    const b = parseInt(mRange[2], 10);
    if (Number.isFinite(a) && Number.isFinite(b)) return Math.min(a, b);
  }

  const nums = Array.from(n.matchAll(/\d+/g)).map((m) => parseInt(m[0], 10)).filter(Number.isFinite);
  if (nums.length) return Math.min(...nums);

  return Number.POSITIVE_INFINITY;
};

const byCurriculumOrder = (a, b) => {
  const ka = gradeKey(a?.displayName);
  const kb = gradeKey(b?.displayName);
  if (ka !== kb) return ka - kb;
  return String(a?.displayName || '').localeCompare(String(b?.displayName || ''));
};

const SettingsSelectSolutionMulti = ({
  solutionLists,
  value,
  onChange,
  translate,
  solutions,
}) => {
  const solutionsMap = keyBy(solutions, '_id');
  const titleStringNumberArr = [...new Set((solutionLists || []).map(item => item.titleStringNumber))];

  const logOrder = (groupNumber, ids) => {
    const rows = ids.map(id => {
      const s = solutionsMap[id];
      return `${gradeKey(s?.displayName)} · ${s?.displayName} [${id}]`;
    });
    console.log(`SettingsSelectSolutionMulti group:${groupNumber} →`, rows.join('  |  '));
  };

  return (
    <div className={classes.listsWrapper}>
      {titleStringNumberArr.map((number) => {
        const rawIds = (solutionLists || [])
          .filter(list => list.titleStringNumber === number)
          .flatMap(list => Array.isArray(list.items) ? list.items : []);

        const seen = new Set();
        const groupIds = [];
        for (const id of rawIds) {
          if (!id) continue;
          if (seen.has(id)) continue;
          if (solutionsMap[id]) {
            seen.add(id);
            groupIds.push(id);
          }
        }

        const sortedIds = [...groupIds].sort((a, b) =>
          byCurriculumOrder(solutionsMap[a], solutionsMap[b])
        );

        logOrder(number, sortedIds);

        return (
          <div className={classes.radioListWrapper} key={number}>
            <p className={classes.radioListLabel}>
              {translate(number, 'Modules')}
            </p>

            <div className={classes.radioList}>
              {sortedIds.map((solutionId) => {
                const solution = solutionsMap[solutionId];
                if (!solution) return null;
                return (
                  <label key={solutionId}>
                    <input
                      checked={solutionId === value}
                      value={solutionId}
                      onChange={() => onChange(solutionId)}
                      type="radio"
                    />
                    <span>{solution.displayName}</span>
                  </label>
                );
              })}
              {!sortedIds.length && <div style={{ color: '#999' }}>—</div>}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default SettingsSelectSolutionMulti;


/*import { keyBy } from 'lodash';

import classes from './SettingsSelectSolutionMulti.module.scss';

const SettingsSelectSolutionMulti = ({
  solutionLists,
  value,
  onChange,
  translate,
  solutions,
}) => {
  const solutionsMap = keyBy(solutions, '_id');
  const titleStringNumberArr = [...new Set(solutionLists.map(item => item.titleStringNumber))];
  const uniqSolutions = [];
  console.log('SettingsSelectSolutionMulti solutionLists:', [solutionLists, solutionsMap, titleStringNumberArr])
  
  return (
    <div className={classes.listsWrapper}>
      {titleStringNumberArr.map((number) => (
        <div className={classes.radioListWrapper} key={number}>
          <p className={classes.radioListLabel}>
            {translate(number, 'Modules')} 
          </p>

          {solutionLists.map((list) => (
            <div className={classes.radioList} key={list.id}>
              {list.items
              .filter((solutionId) => {
                const solution = solutionsMap[solutionId];
                const notUsed = !uniqSolutions.includes(solutionId);
                const sameGroup = list.titleStringNumber === number;
                return solution && notUsed && sameGroup;
              })
              .map((solutionId) => {
                uniqSolutions.push(solutionId);
                const solution = solutionsMap[solutionId];
                return (
                  <label key={solutionId}>
                    <input
                      checked={solutionId === value}
                      value={solutionId}
                      onChange={() => onChange(solutionId)}
                      type="radio"
                    />
                    <span>{solution.displayName}</span>
                  </label>
                );
              })}
            </div>
          ))}
        
        </div>
      ))}
    </div>
  );
};

export default SettingsSelectSolutionMulti;

*/